import { render, staticRenderFns } from "./RefNumSetupGrid.vue?vue&type=template&id=7628d8d9"
import script from "./RefNumSetupGrid.vue?vue&type=script&lang=js"
export * from "./RefNumSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports